import { useMemo } from 'react';
import { ScreenReaderOnly } from 'foundations-components/transitional/components/ScreenReaderOnly';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import PropTypes from 'prop-types';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TimelineFilterButton = ({
  total,
  selected,
  onClick
}) => {
  const dropdownText = useMemo(() => {
    if (total > 0) {
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        "data-selenium-test": "timeline-filter-popover-text",
        message: "timeline.filters.timelineFilterDropdown",
        options: {
          selected,
          total
        }
      });
    }
    return I18n.text('timeline.filters.timelineFilterDropdownLoading');
  }, [total, selected]);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(View, {
      as: "span",
      marginInlineEnd: "200",
      flexShrink: 0,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "topbarContents.filterBy"
      })
    }, "filter-by-text"), /*#__PURE__*/_jsx(ScreenReaderOnly, {
      children: /*#__PURE__*/_jsx("div", {
        id: "timeline-activities-filter-popover-button",
        children: /*#__PURE__*/_jsx("label", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "timeline.filters.accessibility.activities"
          })
        })
      })
    }), /*#__PURE__*/_jsx(Dropdown, {
      "aria-labelledby": "timeline-activities-filter-popover-button",
      "data-selenium-test": "profile-timeline-filter",
      onClick: onClick,
      buttonUse: "transparent",
      responsive: false,
      buttonStyles: {
        marginBlockStart: '0',
        paddingInline: '0'
      },
      open: false,
      buttonText: dropdownText
    }, "timeline-adv-filter")]
  });
};
TimelineFilterButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired
};
export default TimelineFilterButton;